document.addEventListener("DOMContentLoaded", function () {
    const paymentContainer = document.querySelector(".product-form__payment-container");

    if (!paymentContainer || window.innerWidth > 768) return;

    const isFloatingBtn = paymentContainer.getAttribute("data-floating-btn") === "true";
    if (!isFloatingBtn) return;

    let isFloating = false;

    // Dynamically create a small invisible sentinel just above the paymentContainer
    const sentinel = document.createElement('div');
    sentinel.style.height = '1px';
   sentinel.setAttribute("style", "display: block !important;");
    sentinel.classList.add('floating-sentinel');
    sentinel.style.marginBottom = '5px';

    paymentContainer.parentNode.insertBefore(sentinel, paymentContainer);

    // Set up the intersection observer on the new sentinel
    const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting && !isFloating) {
            isFloating = true;
            paymentContainer.classList.add("visible");
        } else if (entry.isIntersecting && isFloating) {
            isFloating = false;
            paymentContainer.classList.remove("visible");
        }
    }, {
        threshold: 0,
        rootMargin: '0px 0px 0px 0px',
    });

    observer.observe(sentinel);
});




document.addEventListener("click", function (event) {
    if (event.target.classList.contains("picky-cart-item__remove-button")) {
        event.preventDefault();
        console.log("Remove button clicked", event.target);
        
    }
});






const ACC_CATS = ['physical', 'feel', 'cycle'];
const accOpenState = { physical: true, feel: false, cycle: false };


function toggleAcc(cat) {
  const willOpen = !accOpenState[cat];

  ACC_CATS.forEach(c => { accOpenState[c] = false; applyAccState(c); });

  if (willOpen) {
    accOpenState[cat] = true;
    applyAccState(cat);
  }
}

function applyAccState(cat) {
  const item = document.getElementById('acc-' + cat);
  const body = document.getElementById('body-' + cat);
  if (!item || !body) return;
  if (accOpenState[cat]) {
    item.classList.add('open');
    body.style.maxHeight = '1000px';
  } else {
    item.classList.remove('open');
    body.style.maxHeight = '0';
  }
}

function filterAcc(cat, query) {
  const grid = document.getElementById('grid-' + cat);
  if (!grid) return;
  const q = query.toLowerCase().trim();
  grid.querySelectorAll('.acc-opt').forEach(opt => {
    const label = opt.querySelector('.acc-opt-text').textContent.toLowerCase();
    opt.classList.toggle('hidden', q.length > 0 && !label.includes(q));
  });
}

function pickAcc(el, qKey) {

  const noneBtn = document.getElementById('accNoneOpt');
  noneBtn.classList.remove('sel');
  if (!answers[qKey]) answers[qKey] = [];
  answers[qKey] = answers[qKey].filter(v => v !== 'lucky');

  el.classList.toggle('sel');
  const v = el.dataset.v;
  if (el.classList.contains('sel')) {
    if (!answers[qKey].includes(v)) answers[qKey].push(v);
  } else {
    answers[qKey] = answers[qKey].filter(x => x !== v);
  }
  updateAccBadges();
  if (typeof revealSkip === 'function') revealSkip();
  if (typeof updateContinueBtn === 'function') updateContinueBtn();
}

function pickAccNone() {
  const noneBtn = document.getElementById('accNoneOpt');
  const willSelect = !noneBtn.classList.contains('sel');


  document.querySelectorAll('.acc-opt.sel').forEach(o => o.classList.remove('sel'));
  answers['q11'] = [];

  if (willSelect) {
    noneBtn.classList.add('sel');
    answers['q11'] = ['lucky'];

    ACC_CATS.forEach(c => { accOpenState[c] = false; applyAccState(c); });
  } else {
    noneBtn.classList.remove('sel');
  }

  updateAccBadges();
  if (typeof revealSkip === 'function') revealSkip();
  if (typeof updateContinueBtn === 'function') updateContinueBtn();
}

function updateAccBadges() {
  const cats = { physical: [], feel: [], cycle: [] };
  document.querySelectorAll('.acc-opt.sel').forEach(opt => {
    const cat = opt.dataset.cat;
    if (cats[cat]) cats[cat].push(opt.dataset.v);
  });
  Object.keys(cats).forEach(cat => {
    const badge = document.getElementById('badge-' + cat);
    if (!badge) return;
    const count = cats[cat].length;
    if (count > 0) {
      badge.textContent = count + ' selected';
      badge.classList.add('show');
    } else {
      badge.textContent = '';
      badge.classList.remove('show');
    }
  });
}


(function initAccordion() {
  ACC_CATS.forEach(cat => applyAccState(cat));
})();


document.addEventListener('DOMContentLoaded', function () {
  ACC_CATS.forEach(cat => applyAccState(cat));
});


const answers = {};
let currentPage = 'intro';
let nudgeOn = true;
let tcOn = false;
let selectedSize = null;
let cupModuleEnabled = false;
let cupModuleExpanded = false;


function buildPageOrder() {

  let pages = ['intro', 'q1', 'q2', 'q3', 'flow', 'q4', 'q5', 'q8', 'q9', 'result'];
  return pages;
}


const matrixProducts = [
  {
    id: 'pads', label: 'Disposable pads', icon: `
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="22" viewBox="0 0 13 22" fill="none">
        <path d="M3.68354 5.67824C3.78803 5.67582 3.88758 5.63162 3.96148 5.55486C4.03538 5.47809 4.07792 5.37467 4.08025 5.26613C4.08025 5.18258 4.10584 3.00812 6.45684 3.00812C8.76213 3.00812 8.83342 5.01735 8.83342 5.26613C8.83342 5.37543 8.87522 5.48025 8.94962 5.55753C9.02401 5.63482 9.12492 5.67824 9.23013 5.67824C9.33535 5.67824 9.43625 5.63482 9.51064 5.55753C9.58504 5.48025 9.62684 5.37543 9.62684 5.26613C9.6112 4.73439 9.4753 4.21394 9.23013 3.74687C8.8645 3.03091 8.06378 2.17822 6.4477 2.17822C3.32157 2.17822 3.26855 5.23195 3.26855 5.26044C3.26927 5.31622 3.28058 5.3713 3.30185 5.42252C3.32311 5.47374 3.35391 5.5201 3.39247 5.55892C3.43103 5.59774 3.4766 5.62827 3.52655 5.64874C3.5765 5.66922 3.62985 5.67924 3.68354 5.67824Z" fill="currentcolor"/>
        <path d="M9.21966 16.5714C9.11532 16.5743 9.01602 16.6186 8.94221 16.6953C8.86841 16.7719 8.82572 16.8751 8.82295 16.9835C8.82295 17.067 8.79736 19.2415 6.44637 19.2415C4.14108 19.2415 4.06978 17.2323 4.06978 16.9835C4.06978 16.8742 4.02799 16.7694 3.95359 16.6921C3.87919 16.6148 3.77829 16.5714 3.67307 16.5714C3.56786 16.5714 3.46696 16.6148 3.39256 16.6921C3.31816 16.7694 3.27637 16.8742 3.27637 16.9835C3.29201 17.5152 3.42791 18.0357 3.67307 18.5028C4.0387 19.2187 4.81201 20.0448 6.45551 20.0448C9.58163 20.0448 9.63465 16.9892 9.63465 16.9626C9.63675 16.9071 9.62712 16.8519 9.60645 16.8007C9.58578 16.7496 9.55457 16.7037 9.51501 16.6664C9.47545 16.6291 9.42851 16.6013 9.37748 16.5849C9.32646 16.5685 9.27258 16.5639 9.21966 16.5714Z" fill="currentcolor"/>
        <path d="M11.5777 8.01225H10.8629C10.9484 7.6844 11.0547 7.36276 11.181 7.04942C11.45 6.28403 11.5493 5.46547 11.4716 4.65467C11.3333 3.32857 10.7112 2.1079 9.73323 1.24353C8.75527 0.379171 7.49573 -0.0632142 6.21349 0.00730074C4.93124 0.0778156 3.72371 0.655874 2.83906 1.62267C1.95442 2.58946 1.45987 3.87154 1.45707 5.20541C1.45069 5.8559 1.56812 6.50129 1.80259 7.10449C1.90862 7.40645 2.01466 7.67422 2.09327 7.98377H1.43148C1.24283 7.98301 1.05592 8.02114 0.881558 8.09596C0.7072 8.17077 0.548865 8.28079 0.415726 8.41962C0.282587 8.55846 0.177291 8.72335 0.105937 8.90476C0.034583 9.08617 -0.00141028 9.28049 4.22745e-05 9.47645V12.477C-0.000441245 12.6723 0.0362678 12.8658 0.108055 13.0464C0.179843 13.2269 0.285292 13.3909 0.418334 13.5289C0.551375 13.6669 0.709382 13.7763 0.88326 13.8506C1.05714 13.925 1.24345 13.9628 1.43148 13.9621H2.09327C2.00826 14.2901 1.90198 14.6118 1.77517 14.9249C1.50629 15.6903 1.40694 16.5089 1.4845 17.3197C1.59421 18.5006 2.09063 19.6066 2.89083 20.4531C3.69104 21.2995 4.74658 21.8352 5.88118 21.9705C6.06309 21.9938 6.24639 22.0033 6.42962 21.999C7.08954 22.0033 7.74375 21.8718 8.35454 21.6123C8.96534 21.3527 9.52065 20.9701 9.98848 20.4866C10.4563 20.0031 10.8274 19.4282 11.0804 18.795C11.3334 18.1619 11.4632 17.483 11.4625 16.7974C11.4686 16.1471 11.3519 15.5019 11.1188 14.8983C11.0128 14.5964 10.9067 14.3286 10.8263 14.0172H11.5685C11.7566 14.0179 11.9429 13.98 12.1168 13.9057C12.2906 13.8313 12.4486 13.722 12.5817 13.584C12.7147 13.446 12.8202 13.282 12.892 13.1014C12.9637 12.9209 13.0005 12.7274 13 12.5321V9.52583C13.0024 9.12984 12.8545 8.74883 12.5882 8.46546C12.3219 8.1821 11.9588 8.01925 11.5777 8.01225ZM1.40406 13.1854C1.23637 13.1829 1.07619 13.1128 0.957442 12.9898C0.83869 12.8668 0.770697 12.7006 0.767863 12.5264V9.52583C0.770684 9.35146 0.838618 9.18506 0.957321 9.06175C1.07602 8.93845 1.23621 8.86788 1.40406 8.86494H2.27791C2.27791 8.89343 2.27791 8.92002 2.30533 8.92002C2.33092 9.05865 2.35835 9.1688 2.38394 9.29983C2.38394 9.35491 2.41136 9.38339 2.41136 9.43847C2.43696 9.5752 2.43696 9.71194 2.46438 9.81828C2.46035 9.86607 2.46922 9.91407 2.48997 9.95692C2.51146 10.0822 2.52064 10.2095 2.5174 10.3367V10.4735C2.5174 10.6387 2.54299 10.8039 2.54299 10.9976C2.54723 11.1627 2.53867 11.3278 2.5174 11.4914V11.6566C2.5174 11.7667 2.48997 11.8769 2.48997 11.987C2.48997 12.0972 2.46438 12.1523 2.46438 12.2073C2.46438 12.2909 2.43696 12.3972 2.43696 12.4827C2.43249 12.5681 2.41458 12.6521 2.38394 12.7315C2.35835 12.8131 2.35835 12.8967 2.33092 12.9784C2.3035 13.06 2.29985 13.0847 2.29985 13.1303H1.40406V13.1854ZM9.26507 20.0676C8.68801 20.6082 7.97846 20.9727 7.21466 21.121C6.45086 21.2693 5.66247 21.1956 4.93642 20.908C4.21037 20.6205 3.57486 20.1302 3.09996 19.4914C2.62505 18.8525 2.32919 18.0898 2.245 17.2874C2.16402 16.6075 2.24564 15.9174 2.48266 15.2782C2.66628 14.7752 2.81713 14.26 2.93421 13.7361V13.681C2.98723 13.4911 3.01282 13.3012 3.06584 13.1113C3.06584 13.0296 3.09326 12.9746 3.09326 12.891C3.12346 12.7557 3.14122 12.6177 3.14628 12.4789C3.14628 12.3953 3.17187 12.3403 3.17187 12.2586C3.20005 12.12 3.21414 11.9787 3.21392 11.837C3.21003 11.7726 3.21873 11.708 3.23951 11.6471C3.23951 11.4572 3.26693 11.2673 3.26693 11.0774C3.27153 10.875 3.26236 10.6726 3.23951 10.4716V10.3063C3.23691 10.1485 3.21915 9.99141 3.1865 9.83728C3.19055 9.78088 3.18178 9.72428 3.1609 9.67205C3.13348 9.48215 3.10789 9.31503 3.08046 9.12322V9.03966C3.04978 8.81675 3.00582 8.59603 2.94884 8.37878C2.81538 7.88312 2.68376 7.38936 2.49729 6.85951C2.33047 6.33535 2.2417 5.7878 2.23403 5.23579C2.23184 4.61796 2.35585 4.00667 2.59788 3.44229C2.8399 2.87792 3.19443 2.3733 3.63805 1.96177C4.40466 1.23286 5.40682 0.829584 6.44608 0.831817C6.60562 0.827097 6.76525 0.836628 6.92322 0.860303C7.87314 0.968009 8.75879 1.41077 9.43248 2.11474C10.1062 2.81872 10.5271 3.74134 10.6252 4.72874C10.7066 5.40875 10.6243 6.09912 10.3857 6.73797C9.87705 8.0896 9.60764 9.52558 9.59048 10.9767C9.59974 12.4065 9.86058 13.8224 10.3601 15.1547C10.55 15.6635 10.6485 16.2042 10.6508 16.7499C10.6653 17.3736 10.5497 17.993 10.3117 18.5658C10.0737 19.1385 9.71918 19.6509 9.27239 20.0676H9.26507ZM12.2066 12.4979C12.2047 12.6726 12.137 12.8395 12.0181 12.963C11.8992 13.0865 11.7385 13.1568 11.5704 13.1588H10.7093C10.552 12.4551 10.4722 11.7352 10.4716 11.0128C10.4749 10.2812 10.5546 9.55211 10.7093 8.83836H11.5832C11.751 8.84032 11.9114 8.91032 12.0303 9.03343C12.1491 9.15653 12.217 9.32301 12.2194 9.49734L12.2066 12.4979Z" fill="currentcolor"/>
        <path d="M4.08064 14.5071C4.13365 14.5071 4.15925 14.5356 4.21226 14.5356C4.29287 14.5335 4.37097 14.506 4.43625 14.4569C4.50153 14.4077 4.55092 14.3391 4.57789 14.2602C5.53218 11.2046 4.63091 8.14895 4.57789 8.01222C4.56393 7.95787 4.53955 7.90701 4.5062 7.86269C4.47286 7.81836 4.43125 7.78149 4.38385 7.75428C4.33646 7.72707 4.28427 7.71008 4.2304 7.70434C4.17654 7.69859 4.12211 7.7042 4.07038 7.72083C4.01865 7.73746 3.97069 7.76477 3.92937 7.80113C3.88805 7.83748 3.85422 7.88213 3.82991 7.93239C3.8056 7.98266 3.79132 8.03751 3.78791 8.09364C3.7845 8.14978 3.79204 8.20606 3.81007 8.2591C3.81007 8.28758 4.68392 11.2046 3.81007 13.9848C3.78318 14.0913 3.79615 14.2044 3.84636 14.3013C3.89657 14.3982 3.98029 14.4718 4.08064 14.5071Z" fill="currentcolor"/>
        <path d="M8.74387 7.7369C8.69334 7.72018 8.64013 7.71406 8.5873 7.71888C8.53448 7.72371 8.48311 7.73938 8.43617 7.765C8.38922 7.79062 8.34765 7.82567 8.31386 7.86812C8.28006 7.91056 8.25472 7.95956 8.2393 8.01227C7.28684 11.0679 8.18628 14.1216 8.2393 14.2603C8.26628 14.3392 8.31566 14.4078 8.38094 14.4569C8.44622 14.5061 8.52432 14.5335 8.60493 14.5356C8.65114 14.54 8.69757 14.5301 8.73838 14.5071C8.83959 14.4735 8.92405 14.3999 8.97361 14.3023C9.02318 14.2046 9.0339 14.0907 9.00346 13.9849C9.00346 13.9564 8.12778 11.0394 9.00346 8.25915C9.03415 8.15412 9.02419 8.0408 8.97572 7.94328C8.92724 7.84576 8.84407 7.77172 8.74387 7.7369Z" fill="currentcolor"/>
      </svg>
    ` },
  {
    id: 'tampons', label: 'Tampons', icon: `
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="28" viewBox="0 0 9 28" fill="none">
  <path d="M8.943 27.2017C8.899 27.1122 8.83157 27.0352 8.74728 26.9782C8.66299 26.9212 8.56473 26.8861 8.46209 26.8764C6.34368 26.6595 4.68454 24.8346 4.68454 22.7235V20.4625H6.7236C7.11198 20.4625 7.48445 20.3144 7.75907 20.0509C8.03369 19.7874 8.18797 19.4301 8.18797 19.0574V3.92698C8.18865 3.39519 8.07661 2.86882 7.85867 2.37987C7.64073 1.89092 7.32144 1.4496 6.9202 1.08274C6.51896 0.71588 6.04416 0.431141 5.52466 0.245832C5.00516 0.0605227 4.45181 -0.0214858 3.89825 0.00479135C2.83267 0.0658679 1.83272 0.519003 1.10664 1.26983C0.38056 2.02065 -0.0156665 3.01129 0.000474462 4.03542V19.0574C0.000474462 19.4301 0.154756 19.7874 0.429379 20.0509C0.704002 20.3144 1.07647 20.4625 1.46485 20.4625H3.50631V22.8412C3.50236 24.124 3.99557 25.3624 4.89011 26.3158C5.78465 27.2692 7.01663 27.8695 8.34667 28H8.4116C8.51047 27.9999 8.60773 27.9759 8.6944 27.9302C8.78107 27.8846 8.85437 27.8187 8.90755 27.7387C8.96072 27.6588 8.99206 27.5672 8.99868 27.4726C9.0053 27.3779 8.98698 27.2832 8.94541 27.1971L8.943 27.2017ZM7.01936 3.92698V19.0574C7.01936 19.1308 6.98896 19.2013 6.93485 19.2532C6.88074 19.3051 6.80734 19.3343 6.73082 19.3343H1.46485C1.38832 19.3343 1.31493 19.3051 1.26081 19.2532C1.2067 19.2013 1.1763 19.1308 1.1763 19.0574V3.92698C1.1763 3.18475 1.4836 2.47291 2.03059 1.94807C2.57758 1.42323 3.31946 1.12838 4.09302 1.12838C4.86658 1.12838 5.60847 1.42323 6.15546 1.94807C6.70245 2.47291 7.00974 3.18475 7.00974 3.92698H7.01936Z" fill="currentcolor"/>
  <path d="M4.09304 4.2041C4.01547 4.2044 3.93873 4.2194 3.86722 4.24823C3.79571 4.27706 3.73083 4.31916 3.67632 4.37211C3.62181 4.42506 3.57873 4.48781 3.54956 4.55677C3.52038 4.62574 3.5057 4.69955 3.50633 4.77397V15.6961C3.50119 15.7732 3.51258 15.8505 3.53979 15.9233C3.56701 15.996 3.60948 16.0626 3.66458 16.1189C3.71968 16.1753 3.78623 16.2202 3.86013 16.2509C3.93403 16.2816 4.01371 16.2975 4.09424 16.2975C4.17477 16.2975 4.25445 16.2816 4.32835 16.2509C4.40225 16.2202 4.46881 16.1753 4.5239 16.1189C4.579 16.0626 4.62147 15.996 4.64869 15.9233C4.67591 15.8505 4.6873 15.7732 4.68215 15.6961V4.77397C4.68279 4.69936 4.66802 4.62535 4.6387 4.55624C4.60938 4.48713 4.56608 4.42427 4.51132 4.37129C4.45655 4.31831 4.39139 4.27626 4.3196 4.24757C4.24781 4.21887 4.17081 4.2041 4.09304 4.2041Z" fill="currentcolor"/>
</svg>
` },
  {
    id: 'reusable', label: 'Reusable pads', icon: `
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="23" viewBox="0 0 14 23" fill="none">
  <path d="M3.96693 5.93645C4.07945 5.93392 4.18667 5.88772 4.26625 5.80746C4.34583 5.72721 4.39165 5.61909 4.39415 5.50562C4.39415 5.41826 4.42172 3.14497 6.95355 3.14497C9.43617 3.14497 9.51296 5.24553 9.51296 5.50562C9.51296 5.61988 9.55797 5.72946 9.63809 5.81026C9.71821 5.89106 9.82687 5.93645 9.94018 5.93645C10.0535 5.93645 10.1622 5.89106 10.2423 5.81026C10.3224 5.72946 10.3674 5.61988 10.3674 5.50562C10.3506 4.9497 10.2042 4.40559 9.94018 3.91729C9.54643 3.16879 8.6841 2.27734 6.94371 2.27734C3.57711 2.27734 3.52002 5.46988 3.52002 5.49966C3.52079 5.55797 3.53297 5.61556 3.55588 5.66911C3.57878 5.72266 3.61194 5.77112 3.65347 5.81171C3.695 5.85229 3.74407 5.88421 3.79786 5.90561C3.85165 5.92702 3.90911 5.9375 3.96693 5.93645Z" fill="currentcolor"/>
  <path d="M9.92879 17.3245C9.81642 17.3275 9.70948 17.3738 9.63 17.454C9.55052 17.5342 9.50455 17.642 9.50157 17.7553C9.50157 17.8427 9.474 20.116 6.94217 20.116C4.45955 20.116 4.38277 18.0154 4.38277 17.7553C4.38277 17.641 4.33776 17.5315 4.25764 17.4507C4.17752 17.3699 4.06885 17.3245 3.95554 17.3245C3.84224 17.3245 3.73357 17.3699 3.65345 17.4507C3.57333 17.5315 3.52832 17.641 3.52832 17.7553C3.54517 18.3112 3.69152 18.8553 3.95554 19.3436C4.3493 20.0921 5.18209 20.9558 6.95201 20.9558C10.3186 20.9558 10.3757 17.7613 10.3757 17.7335C10.378 17.6755 10.3676 17.6177 10.3453 17.5642C10.3231 17.5107 10.2895 17.4628 10.2469 17.4238C10.2043 17.3848 10.1537 17.3557 10.0988 17.3386C10.0438 17.3214 9.98579 17.3166 9.92879 17.3245Z" fill="currentcolor"/>
  <path d="M12.4683 8.37645H11.6985C11.7906 8.0337 11.9051 7.69743 12.041 7.36985C12.3307 6.56967 12.4377 5.7139 12.3541 4.86625C12.2051 3.47987 11.5351 2.20371 10.4819 1.30006C9.42875 0.396406 8.07233 -0.0660875 6.69145 0.00763259C5.31057 0.0813527 4.01015 0.685686 3.05745 1.69643C2.10476 2.70717 1.57217 4.04752 1.56916 5.44202C1.56229 6.12208 1.68874 6.7968 1.94125 7.42742C2.05544 7.7431 2.16963 8.02305 2.25429 8.34667H1.54159C1.33844 8.34587 1.13714 8.38574 0.94937 8.46396C0.7616 8.54217 0.591085 8.65719 0.447705 8.80233C0.304325 8.94748 0.190928 9.11987 0.114086 9.30953C0.0372432 9.49918 -0.00151876 9.70233 4.55264e-05 9.9072V13.0441C-0.000475186 13.2483 0.0390576 13.4506 0.116367 13.6394C0.193677 13.8281 0.307238 13.9996 0.450513 14.1439C0.593789 14.2882 0.76395 14.4025 0.951203 14.4802C1.13846 14.5579 1.3391 14.5975 1.54159 14.5967H2.25429C2.16274 14.9397 2.04829 15.276 1.91172 15.6033C1.62216 16.4035 1.51516 17.2593 1.59869 18.1069C1.71685 19.3415 2.25145 20.4978 3.1132 21.3827C3.97496 22.2677 5.1117 22.8277 6.33358 22.9692C6.52948 22.9935 6.72688 23.0034 6.92421 22.999C7.63489 23.0034 8.33942 22.866 8.9972 22.5946C9.65498 22.3233 10.253 21.9233 10.7568 21.4178C11.2606 20.9123 11.6603 20.3113 11.9327 19.6494C12.2052 18.9874 12.345 18.2776 12.3442 17.5609C12.3509 16.8811 12.2251 16.2065 11.9741 15.5755C11.8599 15.2599 11.7457 14.9799 11.6591 14.6543H12.4584C12.6609 14.6551 12.8616 14.6155 13.0488 14.5378C13.2361 14.46 13.4062 14.3457 13.5495 14.2014C13.6928 14.0571 13.8063 13.8857 13.8836 13.6969C13.961 13.5082 14.0005 13.3059 14 13.1017V9.95882C14.0026 9.54484 13.8433 9.1465 13.5565 8.85025C13.2698 8.55401 12.8787 8.38376 12.4683 8.37645ZM1.51206 13.7847C1.33148 13.7821 1.15898 13.7088 1.03109 13.5802C0.903205 13.4516 0.829981 13.2779 0.826929 13.0958V9.95882C0.829968 9.77653 0.903127 9.60257 1.03096 9.47365C1.1588 9.34474 1.3313 9.27096 1.51206 9.2679H2.45313C2.45313 9.29768 2.45313 9.32547 2.48266 9.32547C2.51023 9.47041 2.53976 9.58556 2.56732 9.72255C2.56732 9.78013 2.59685 9.80991 2.59685 9.86749C2.62442 10.0104 2.62442 10.1534 2.65395 10.2646C2.64961 10.3145 2.65916 10.3647 2.68151 10.4095C2.70464 10.5405 2.71454 10.6736 2.71104 10.8066V10.9495C2.71104 11.1223 2.7386 11.295 2.7386 11.4975C2.74318 11.67 2.73396 11.8427 2.71104 12.0137V12.1864C2.71104 12.3016 2.68151 12.4168 2.68151 12.5319C2.68151 12.6471 2.65395 12.7046 2.65395 12.7622C2.65395 12.8496 2.62442 12.9608 2.62442 13.0501C2.6196 13.1394 2.60032 13.2272 2.56732 13.3102C2.53976 13.3956 2.53976 13.4829 2.51023 13.5683C2.4807 13.6537 2.47676 13.6795 2.47676 13.7271H1.51206V13.7847ZM9.97777 20.9798C9.35631 21.5449 8.59218 21.926 7.76963 22.081C6.94708 22.236 6.09805 22.159 5.31615 21.8584C4.53425 21.5578 3.84985 21.0453 3.33841 20.3773C2.82698 19.7094 2.50836 18.9121 2.4177 18.0732C2.33048 17.3624 2.41839 16.6409 2.67364 15.9726C2.87137 15.4468 3.03384 14.9082 3.15992 14.3605V14.3029C3.21702 14.1043 3.24458 13.9058 3.30167 13.7073C3.30167 13.6219 3.3312 13.5643 3.3312 13.477C3.36373 13.3355 3.38285 13.1912 3.3883 13.0461C3.3883 12.9588 3.41586 12.9012 3.41586 12.8158C3.44621 12.6709 3.46138 12.5232 3.46114 12.3751C3.45695 12.3077 3.46633 12.2401 3.48871 12.1765C3.48871 11.978 3.51824 11.7794 3.51824 11.5809C3.52318 11.3693 3.51331 11.1577 3.48871 10.9475V10.7748C3.4859 10.6098 3.46677 10.4456 3.43161 10.2844C3.43597 10.2255 3.42653 10.1663 3.40405 10.1117C3.37452 9.91315 3.34695 9.73844 3.31742 9.53791V9.45055C3.28438 9.21751 3.23704 8.98676 3.17567 8.75963C3.03195 8.24144 2.8902 7.72523 2.68939 7.17131C2.50974 6.62332 2.41413 6.05088 2.40588 5.47378C2.40352 4.82786 2.53707 4.18879 2.79771 3.59876C3.05835 3.00873 3.44015 2.48118 3.9179 2.05094C4.74348 1.2889 5.82273 0.867293 6.94193 0.869627C7.11374 0.864693 7.28566 0.874656 7.45578 0.899408C8.47876 1.01201 9.43255 1.4749 10.1581 2.21087C10.8836 2.94684 11.3369 3.9114 11.4425 4.94368C11.5302 5.6546 11.4416 6.37635 11.1846 7.04424C10.6368 8.45731 10.3467 9.95856 10.3282 11.4757C10.3382 12.9704 10.6191 14.4507 11.1571 15.8436C11.3616 16.3755 11.4677 16.9408 11.4701 17.5113C11.4858 18.1633 11.3612 18.8109 11.1049 19.4097C10.8486 20.0084 10.4668 20.5441 9.98565 20.9798H9.97777ZM13.1455 13.066C13.1435 13.2486 13.0706 13.4231 12.9426 13.5523C12.8145 13.6814 12.6415 13.7548 12.4604 13.7569H11.5331C11.3636 13.0213 11.2778 12.2686 11.2772 11.5134C11.2807 10.7485 11.3665 9.9863 11.5331 9.2401H12.4742C12.6549 9.24215 12.8277 9.31533 12.9557 9.44404C13.0837 9.57274 13.1567 9.74678 13.1593 9.92904L13.1455 13.066Z" fill="currentcolor"/>
  <path d="M4.39448 15.1665C4.45157 15.1665 4.47913 15.1963 4.53623 15.1963C4.62303 15.1941 4.70714 15.1654 4.77744 15.114C4.84774 15.0626 4.90093 14.9909 4.92998 14.9084C5.95767 11.7139 4.98707 8.51936 4.92998 8.37641C4.91494 8.31959 4.88868 8.26642 4.85278 8.22008C4.81687 8.17374 4.77205 8.1352 4.72102 8.10675C4.66998 8.0783 4.61377 8.06054 4.55576 8.05453C4.49775 8.04852 4.43914 8.05439 4.38343 8.07178C4.32772 8.08917 4.27607 8.11772 4.23157 8.15573C4.18707 8.19373 4.15064 8.24041 4.12446 8.29296C4.09829 8.34551 4.0829 8.40285 4.07923 8.46154C4.07556 8.52023 4.08368 8.57906 4.1031 8.63451C4.1031 8.66429 5.04417 11.7139 4.1031 14.6205C4.07414 14.7318 4.08811 14.85 4.14218 14.9514C4.19625 15.0527 4.28641 15.1296 4.39448 15.1665Z" fill="currentcolor"/>
  <path d="M9.41651 8.08838C9.3621 8.0709 9.30479 8.0645 9.2479 8.06954C9.19102 8.07459 9.13569 8.09097 9.08514 8.11776C9.03459 8.14454 8.98981 8.18118 8.95342 8.22556C8.91703 8.26994 8.88973 8.32116 8.87313 8.37626C7.8474 11.5708 8.81604 14.7633 8.87313 14.9082C8.90218 14.9908 8.95537 15.0625 9.02567 15.1139C9.09597 15.1653 9.18008 15.1939 9.26688 15.1961C9.31665 15.2007 9.36665 15.1903 9.41061 15.1664C9.5196 15.1312 9.61055 15.0543 9.66393 14.9522C9.71731 14.8501 9.72885 14.7309 9.69608 14.6204C9.69608 14.5906 8.75304 11.541 9.69608 8.63436C9.72912 8.52456 9.7184 8.4061 9.66619 8.30414C9.61399 8.20219 9.52442 8.12478 9.41651 8.08838Z" fill="currentcolor"/>
</svg>
      ` },
  {
    id: 'underwear', label: 'Period underwear', icon: `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
  <path d="M19.4567 0C19.4567 0 16.7066 0.772332 10.005 0.872727H9.99502C3.29336 0.772332 0.543274 0 0.543274 0C0.543274 0 0.381595 1.82925 0 2.83004C0 2.83004 5.91242 6.45455 9.08011 11.9336C9.08011 11.9336 9.46401 11.9779 10.0004 12C10.5368 11.9771 10.9207 11.9336 10.9207 11.9336C14.0883 6.45455 20 2.83004 20 2.83004C19.6192 1.82925 19.4575 0 19.4575 0H19.4567Z" fill="currentcolor"/>
</svg>
      ` },
  {
    id: 'cup', label: 'Menstrual cup', icon: `
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none">
  <path d="M11.4322 1.75H0.570714C0.570714 1.75 0 1.82222 0 2.32774C0 2.99213 0.567746 2.86214 0.594499 3.54387C0.596166 3.55537 0.596166 3.56703 0.594499 3.57853C0.594499 3.94828 0.529094 6.00503 0.529094 6.00503C0.534557 7.0372 0.686604 8.0637 0.980919 9.05547C1.29556 10.0539 1.74218 11.0084 2.30962 11.895C2.66037 12.4728 3.76912 13.5098 4.45874 14.1367C5.14836 14.7635 5.21375 15.0033 5.21375 15.0033C5.319 15.3944 5.36703 15.7979 5.35642 16.2021C5.35642 16.2483 5.35642 16.3003 5.35642 16.3523V16.5487C5.35642 16.8058 5.35642 16.93 5.35642 17.1264V18.9116V18.9348C5.35642 19.1341 5.35642 19.2034 5.35642 19.2236C5.35985 19.2961 5.37797 19.3672 5.40972 19.4329C5.44147 19.4986 5.48624 19.5575 5.54146 19.6063C5.59668 19.6552 5.66128 19.6929 5.73154 19.7175C5.8018 19.742 5.87634 19.7529 5.95092 19.7494H6.04902C6.12359 19.7529 6.19815 19.742 6.26842 19.7175C6.33868 19.6929 6.40328 19.6552 6.4585 19.6063C6.51372 19.5575 6.55848 19.4986 6.59023 19.4329C6.62198 19.3672 6.64008 19.2961 6.64352 19.2236C6.64352 19.1976 6.64352 19.1283 6.64352 18.9348V18.9116V17.1178C6.64352 16.9156 6.64352 16.7914 6.64352 16.54V16.1934C6.63141 15.7892 6.67946 15.3854 6.78619 14.9946C6.78619 14.9946 6.85159 14.7548 7.53824 14.128C8.22489 13.5011 9.33957 12.4699 9.69032 11.8864C10.2566 10.9991 10.7031 10.0447 11.019 9.04681C11.3134 8.05504 11.4654 7.02854 11.4708 5.99636C11.4708 5.99636 11.4055 3.93962 11.4055 3.56986C11.4055 3.56986 11.4055 3.54676 11.4055 3.5352C11.4263 2.85347 12 2.98347 12 2.31907C12.0059 1.80777 11.4322 1.75 11.4322 1.75Z" fill="currentcolor"/>
</svg>
      ` },
  {
    id: 'disc', label: 'Menstrual disc', icon: `
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
  <path d="M0.0139408 7.53145C0.106804 7.09074 0.448807 6.77203 0.861185 6.57816C0.878506 6.56903 0.896738 6.56167 0.9156 6.55618L0.944382 6.54673C0.9925 6.52805 1.04354 6.50937 1.09458 6.49376C1.13303 6.47793 1.17463 6.46563 1.21285 6.4531C1.21938 6.4498 1.22567 6.4498 1.23197 6.44672L1.35676 6.40936C1.37012 6.40086 1.38579 6.3965 1.40173 6.39683C1.76284 6.30605 2.137 6.27176 2.51093 6.25615C2.59097 6.25308 2.67395 6.25308 2.75377 6.25308C2.83696 6.25 2.91701 6.25 2.99706 6.25H19.029C19.4223 6.25 19.9561 6.25923 20.4611 6.3599L20.4996 6.36935C20.5409 6.38188 20.5825 6.39133 20.6244 6.40364C20.6304 6.40672 20.6338 6.40672 20.6401 6.41002C20.6752 6.41925 20.7076 6.432 20.7424 6.44123C20.8447 6.47552 20.947 6.51003 21.0496 6.54739C21.0783 6.55684 21.1037 6.56629 21.1294 6.57553C21.1329 6.57879 21.1372 6.581 21.142 6.5819C21.701 6.85643 22.0591 7.34066 21.9919 8.05743V8.06688C21.9812 8.18572 21.9619 8.30367 21.9344 8.41988C21.8705 8.69508 21.7266 8.95444 21.4966 9.13864C21.359 9.25118 21.2088 9.3325 21.068 9.42614C20.9306 9.51054 20.8027 9.6044 20.6909 9.7387C20.1288 10.4201 19.8884 11.2637 19.4792 12.0262C18.9967 12.9274 18.3349 13.7512 17.6028 14.4699C16.4455 15.6105 15.0197 16.495 13.4309 16.9293C12.6389 17.1436 11.8208 17.2514 10.9991 17.25H10.996C10.1738 17.2512 9.35532 17.1429 8.56306 16.9282C6.97132 16.4939 5.54846 15.6094 4.39137 14.4688C3.65925 13.7501 2.99728 12.9252 2.51475 12.0251C2.10237 11.2626 1.86583 10.4188 1.30325 9.7376C1.19082 9.6033 1.06333 9.50944 0.925943 9.42504C0.78541 9.3314 0.634985 9.2492 0.498724 9.13754C0.268475 8.95334 0.124344 8.69398 0.0607109 8.41879C0.0318394 8.30165 0.011549 8.18266 0 8.06271V7.63981C0.00112343 7.60332 0.00764465 7.56881 0.0139408 7.53145Z" fill="currentcolor"/>
</svg>
      ` },
];
const matrixCols = ['Never tried it', 'Tried it, never again', 'Tried it, would rather not', "It's fine, I don't mind it", 'I like it', 'Best thing ever'];

function buildMatrix() {
  const tbody = document.getElementById('matrixBody');
  if (!tbody) return;
  matrixProducts.forEach((p, idx) => {
    const tr = document.createElement('tr');

    if (idx % 2 === 0) tr.classList.add('row-stripe');
    tr.innerHTML = `<td class="prod-name-cell"><div class="prod-name-inner"><span class="prod-ic">${p.icon}</span><span class="prod-name-txt">${p.label}</span></div></td>` +
      matrixCols.map((c, i) => `<td><div class="radio-circle" title="${c}" data-prod="${p.id}" data-col="${i}"></div></td>`).join('');
    tbody.appendChild(tr);
    tr.querySelectorAll('.radio-circle').forEach(r => {
      r.addEventListener('click', () => pickMatrix(r.dataset.prod, parseInt(r.dataset.col, 10), r));
    });
  });
}
buildMatrix();

function pickMatrix(prodId, colIdx, el) {
  if (!answers.q7) answers.q7 = {};
  answers.q7[prodId] = colIdx;
  document.querySelectorAll(`[data-prod="${prodId}"]`).forEach(r => r.classList.remove('sel'));
  el.classList.add('sel');

  if ((prodId === 'cup' || prodId === 'disc') && colIdx >= 3) {
    cupModuleEnabled = true;
  }

  if (typeof revealSkip === 'function') revealSkip();
}


function showQ3Banner(type) {

  document.querySelectorAll('#page-q6 .q6-inline-banner').forEach(el => el.remove());


  ['first', 'pregnant', 'postpartum'].forEach(t => {
    const el = document.getElementById('banner-' + t);
    if (el) el.classList.remove('show');
  });

  if (!type || type === 'none') return;


  const template = document.getElementById('banner-' + type);
  if (!template) return;


  const pickedOpt = document.querySelector('#page-q6 .opt[data-banner="' + type + '"]');
  if (!pickedOpt) return;


  const banner = template.cloneNode(true);
  banner.removeAttribute('id');
  banner.classList.add('q6-inline-banner');
  banner.classList.add('show');
  banner.style.marginTop = '0';
  banner.style.marginBottom = '0';

  pickedOpt.insertAdjacentElement('afterend', banner);
  banner.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}


function handleQ12TravelBox(val) {

  document.querySelectorAll('#page-q15 .q15-inline-travel-msg').forEach(el => el.remove());

  const showTravel = (val === 'constant' || val === 'fewmonths');
  if (!showTravel) return;


  const pickedOpt = document.querySelector('#page-q15 .opt[data-v="' + val + '"]');
  if (!pickedOpt) return;


  const msg = document.createElement('div');
  msg.className = 'q15-inline-travel-msg';
  msg.style.cssText = 'display:flex;align-items:flex-start;gap:12px;background:var(--pink-light);border:1px solid var(--pink-border);border-radius:14px;padding:14px 16px;margin-top:0;margin-bottom:0;font-size:13px;color:var(--text-mid);line-height:1.55';
  msg.innerHTML = `
        <span style="flex-shrink:0;color:var(--pink);margin-top:1px">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="currentcolor" width="18" height="18"><path d="M272 88C272 83.6 275.6 80 280 80L360 80C364.4 80 368 83.6 368 88L368 160L272 160L272 88zM448 160L416 160L416 88C416 57.1 390.9 32 360 32L280 32C249.1 32 224 57.1 224 88L224 160L192 160C156.7 160 128 188.7 128 224L128 512C128 547.3 156.7 576 192 576C192 593.7 206.3 608 224 608C241.7 608 256 593.7 256 576L384 576C384 593.7 398.3 608 416 608C433.7 608 448 593.7 448 576C483.3 576 512 547.3 512 512L512 224C512 188.7 483.3 160 448 160zM248 272L392 272C405.3 272 416 282.7 416 296C416 309.3 405.3 320 392 320L248 320C234.7 320 224 309.3 224 296C224 282.7 234.7 272 248 272zM248 400L392 400C405.3 400 416 410.7 416 424C416 437.3 405.3 448 392 448L248 448C234.7 448 224 437.3 224 424C224 410.7 234.7 400 248 400z"/></svg>
        </span>
        <span>Travelers, we've got you. A travel kit, some easy underwear packets, or wipes can make life on the road a lot simpler.</span>`;


  pickedOpt.insertAdjacentElement('afterend', msg);
  msg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

function handleQ9Tip(val) {

  document.querySelectorAll('#page-q12 .q12-inline-tip').forEach(el => el.remove());


  if (val === 'none') return;


  const pickedOpt = document.querySelector('#page-q12 .opt[data-v="' + val + '"]');
  if (!pickedOpt) return;


  if (!pickedOpt.classList.contains('selected')) return;


  const template = document.getElementById('q12-tip');
  if (!template) return;
  const tip = template.cloneNode(true);
  tip.removeAttribute('id');
  tip.classList.add('q12-inline-tip');
  tip.style.display = 'flex';
  tip.style.marginTop = '0';
  tip.style.marginBottom = '0';

  pickedOpt.insertAdjacentElement('afterend', tip);
  tip.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}


function applyAgeGating() {
  const isMinor = (answers.q5 === 'u16' || answers.q5 === '16-18');
  const nightout = document.getElementById('opt-nightout');
  const fancy = document.getElementById('opt-fancy');
  const thong = document.getElementById('opt-thong');
  if (nightout) nightout.style.display = isMinor ? 'none' : 'flex';
  if (fancy) fancy.style.display = isMinor ? 'none' : 'flex';
  if (thong) thong.style.display = isMinor ? 'none' : 'flex';
}


function handleSilicone(val) {

  document.querySelectorAll('#page-q18 .silicone-inline-msg').forEach(el => el.remove());

  const staticNotice = document.getElementById('silicone-notice');
  if (staticNotice) staticNotice.style.display = 'none';

  if (val === 'yes') {
    const yepOpt = document.querySelector('#page-q18 .opt[data-v="yes"]');
    if (yepOpt) {
      const msg = document.createElement('div');
      msg.className = 'silicone-inline-msg silicone-notice';
      msg.style.display = 'block';
      msg.style.marginTop = '0';
      msg.innerHTML = '<strong>No problem at all!</strong> We\'ll skip the cup and disc recommendations and focus on finding you the perfect underwear instead. Keep going — great matches are ahead.';
      yepOpt.insertAdjacentElement('afterend', msg);
      msg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }
}


function showCupSub(show) {
  const sub = document.getElementById('cup-sub');
  if (show) {
    sub.classList.add('show');
    cupModuleExpanded = true;
  } else {
    skipCupModule();
  }
}
function skipCupModule() {
  const pages = buildPageOrder();
  const idx = pages.indexOf('cupmodule');
  if (idx !== -1) {
    const next = pages[idx + 1];
    if (next) showPage(next);
  }
}
function showCervixDetail(show) {
  document.getElementById('cervix-detail').style.display = show ? 'block' : 'none';
}
function showPelvicSub(show) {
  document.getElementById('pelvic-sub').style.display = show ? 'block' : 'none';
}


function revealSkip() {
  if (currentPage === 'q10') return;
  const btn = document.getElementById('btnSkip');
  if (btn) {
    btn.style.display = 'inline-flex';
  }
}

function pickMatrixChip(prodId, val, btn, qKey) {
  if (!answers[qKey]) answers[qKey] = {};
  const container = btn.parentElement;
  const wasSel = btn.classList.contains('sel');

  container.querySelectorAll('.matrix-chip').forEach(c => c.classList.remove('sel'));

  if (wasSel) {
    delete answers[qKey][prodId];
    if (Object.keys(answers[qKey]).length === 0) delete answers[qKey];
  } else {
    btn.classList.add('sel');
    answers[qKey][prodId] = val;
  }

  if (typeof revealSkip === 'function') revealSkip();
  if (typeof updateContinueBtn === 'function') updateContinueBtn();
}

function pick(el, qKey, multi) {
  if (multi) {
    el.classList.toggle('selected');
    if (!answers[qKey]) answers[qKey] = [];
    const v = el.dataset.v;
    const clearKeys = ['none', 'nothing', 'all', 'easy', 'lucky', 'trust'];
    if (clearKeys.includes(v)) {
      document.querySelectorAll(`[data-q="${qKey}"]`).forEach(o => o.classList.remove('selected'));
      el.classList.add('selected');
      answers[qKey] = [v];
    } else {
      clearKeys.forEach(k => {
        document.querySelectorAll(`[data-q="${qKey}"][data-v="${k}"]`).forEach(o => o.classList.remove('selected'));
        answers[qKey] = (answers[qKey] || []).filter(x => x !== k);
      });
      if (el.classList.contains('selected')) {
        if (!answers[qKey].includes(v)) answers[qKey].push(v);
      } else {
        answers[qKey] = answers[qKey].filter(x => x !== v);
      }
    }
  } else {
    document.querySelectorAll(`[data-q="${qKey}"]`).forEach(o => o.classList.remove('selected'));
    el.classList.add('selected');
    answers[qKey] = el.dataset.v;
  }
  revealSkip();
  updateContinueBtn();
}

function pickSize(btn, size) {
  document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('sel'));
  btn.classList.add('sel');
  selectedSize = size;
  answers.q20 = size;
  revealSkip();
  updateContinueBtn();
}

function toggleNudge() {
  nudgeOn = !nudgeOn;
  const nc = document.getElementById('nudgeCheck');
  if (nc) nc.classList.toggle('on', nudgeOn);
  const nc2 = document.getElementById('nudgeCheck2');
  if (nc2) nc2.classList.toggle('on', nudgeOn);
  const pw = document.getElementById('phoneWrap');
  if (pw) pw.classList.toggle('show', nudgeOn);
  const pw2 = document.getElementById('phoneWrap2');
  if (pw2) pw2.classList.toggle('show', nudgeOn);
}
function toggleTC() {
  tcOn = !tcOn;
  answers.teen = tcOn;
  document.getElementById('tcCheck').classList.toggle('on', tcOn);
  updateContinueBtn();
}


function skipPage() {
  const pages = buildPageOrder();
  const idx = pages.indexOf(currentPage);
  if (idx < pages.length - 1) showPage(pages[idx + 1]);
}


function showPage(p) {
  document.querySelectorAll('.screen').forEach(s => s.classList.remove('active'));
  const el = document.getElementById('page-' + p);
  if (!el) return;
  el.classList.add('active');
  document.getElementById('appMain').scrollTop = 0;
  window.scrollTo(0, 0);
  currentPage = p;

  const pages = buildPageOrder();
  const progress = document.getElementById('headerProgress');
  const footer = document.getElementById('appFooter');
  const btnBack = document.getElementById('btnBack');
  const btnCont = document.getElementById('btnContinue');
  const btnSkip = document.getElementById('btnSkip');
  const introTime = document.getElementById('introTimeLeft');

  if (p !== 'result') {
    const existingTag = document.getElementById('resultHeaderTag');
    if (existingTag) existingTag.style.display = 'none';
    const retakeBtn = document.getElementById('btnRetake');
    if (retakeBtn) retakeBtn.style.display = 'none';
    const qPages = pages.filter(x => x !== 'result');
    const qNum = qPages.indexOf(p) + 1;
    const qTotal = qPages.length;

    progress.style.display = 'flex';
    document.getElementById('progressLabel').textContent = qNum + '/' + qTotal;
    document.getElementById('progressFill').style.width = (qNum / qTotal * 100) + '%';
  }

  if (p === 'intro') {
    if (introTime) introTime.style.display = 'flex';
    btnBack.style.display = 'none';
    btnSkip.style.display = 'none';
    btnCont.innerHTML = `
          <span>LET'S GO</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
            <path d="M10.2797 6.52949C10.5727 6.23652 10.5727 5.76074 10.2797 5.46777L6.52969 1.71777C6.23672 1.4248 5.76094 1.4248 5.46797 1.71777C5.175 2.01074 5.175 2.48652 5.46797 2.77949L7.94063 5.2498H0.75C0.335156 5.2498 0 5.58496 0 5.9998C0 6.41465 0.335156 6.7498 0.75 6.7498H7.93828L5.47031 9.22012C5.17734 9.51309 5.17734 9.98887 5.47031 10.2818C5.76328 10.5748 6.23906 10.5748 6.53203 10.2818L10.282 6.53184L10.2797 6.52949Z" fill="currentColor"/>
          </svg>
        `;
    btnCont.classList.remove('pink');
    updateContinueBtn();
  } else if (p === 'result') {
    progress.style.display = 'none';
    if (introTime) introTime.style.display = 'none';

    let resultTag = document.getElementById('resultHeaderTag');
    if (!resultTag) {
      resultTag = document.createElement('div');
      resultTag.id = 'resultHeaderTag';
      resultTag.className = 'result-tag';
      resultTag.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none"><path d="M6.86148 0.421875C6.73726 0.164062 6.47476 0 6.18648 0C5.8982 0 5.63804 0.164062 5.51148 0.421875L4.00445 3.52266L0.638823 4.01953C0.357573 4.06172 0.123198 4.25859 0.0364792 4.52812C-0.0502396 4.79766 0.0200729 5.09531 0.221635 5.29453L2.66382 7.71094L2.08726 11.1258C2.04039 11.407 2.15757 11.693 2.3896 11.8594C2.62164 12.0258 2.92867 12.0469 3.18179 11.9133L6.18882 10.3078L9.19585 11.9133C9.44898 12.0469 9.75601 12.0281 9.98804 11.8594C10.2201 11.6906 10.3373 11.407 10.2904 11.1258L9.71148 7.71094L12.1537 5.29453C12.3552 5.09531 12.4279 4.79766 12.3388 4.52812C12.2498 4.25859 12.0177 4.06172 11.7365 4.01953L8.36851 3.52266L6.86148 0.421875Z" fill="currentColor"/></svg> YOUR RESULTS ARE IN`;
      document.getElementById('appHeader').appendChild(resultTag);
    }
    resultTag.style.display = 'inline-flex';

    footer.style.display = 'flex';
    btnBack.style.display = 'none';
    btnSkip.style.display = 'none';
    document.getElementById('btnRetake').style.display = 'inline-flex';
    btnCont.innerHTML = `SHOP YOUR SET &rarr;`;
    btnCont.disabled = false;
    document.getElementById('textNudgeMsg').classList.add('show');
  } else {
    if (introTime) introTime.style.display = 'none';
    footer.style.display = 'flex';
    btnBack.style.display = 'flex';


    if (p === 'q10') {
      btnSkip.style.display = 'inline-flex';
      btnSkip.style.opacity = '1';
      btnSkip.style.pointerEvents = 'auto';
    } else {

      btnSkip.style.display = 'none';
      btnSkip.style.opacity = '';
      btnSkip.style.pointerEvents = '';
    }

    if (p === 'q21') {
      btnCont.textContent = 'Show me my fit →';
      btnCont.classList.add('pink');
    } else {
      btnCont.innerHTML = `
            <span>CONTINUE </span>
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
              <path d="M10.2797 6.52949C10.5727 6.23652 10.5727 5.76074 10.2797 5.46777L6.52969 1.71777C6.23672 1.4248 5.76094 1.4248 5.46797 1.71777C5.175 2.01074 5.175 2.48652 5.46797 2.77949L7.94063 5.2498H0.75C0.335156 5.2498 0 5.58496 0 5.9998C0 6.41465 0.335156 6.7498 0.75 6.7498H7.93828L5.47031 9.22012C5.17734 9.51309 5.17734 9.98887 5.47031 10.2818C5.76328 10.5748 6.23906 10.5748 6.53203 10.2818L10.282 6.53184L10.2797 6.52949Z" fill="currentColor"/>
            </svg>
          `;
      btnCont.classList.remove('pink');
    }


    if (p === 'q17') applyAgeGating();


    if (p === 'q5') {
      const laceTag = document.getElementById('tagLaceMesh');
      if (laceTag) laceTag.style.display = ['vheavy', 'heavy'].includes(answers.flow) ? '' : 'none';
    }

    updateContinueBtn();
  }
}

function updateContinueBtn() {
  const btn = document.getElementById('btnContinue');
  if (!btn) return;
  if (currentPage === 'result') return;

  if (currentPage === 'intro') {
    const ageAns = answers['introAge'];
    const hasAge = ageAns && (Array.isArray(ageAns) ? ageAns.length > 0 : true);
    btn.disabled = !hasAge;
    return;
  }

  if (currentPage === 'q9') {
    const nameVal = document.getElementById('userFirst')?.value.trim();
    const emailVal = document.getElementById('userEmail')?.value.trim();

    btn.disabled = !(nameVal && emailVal);
    return;
  }


  const alwaysOk = ['q10', 'q11', 'q14', 'q15', 'q18', 'q20', 'q21', 'q7', 'q8', 'cupmodule'];
  if (alwaysOk.includes(currentPage)) { btn.disabled = false; return; }

  const ans = answers[currentPage];
  btn.disabled = !(ans && (Array.isArray(ans) ? ans.length > 0 : true));
}

function goNext() {
  const pages = buildPageOrder();
  const idx = pages.indexOf(currentPage);
  if (idx < pages.length - 1) showPage(pages[idx + 1]);
}

function goBack() {
  const pages = buildPageOrder();
  const idx = pages.indexOf(currentPage);
  if (idx > 0) showPage(pages[idx - 1]);
}

function initDropdowns() {
  document.querySelectorAll('[data-dropdown]').forEach(initSingleDropdown);
}

function initSingleDropdown(dropdown) {
  if (dropdown.dataset.ready) return;

  const input = dropdown.querySelector('input[type="hidden"]');
  const trigger = dropdown.querySelector('.pant-dropdown-trigger');
  const menu = dropdown.querySelector('.pant-dropdown-menu');
  const title = dropdown.querySelector('.pant-dropdown-trigger-title');
  const hint = dropdown.querySelector('.pant-dropdown-trigger-hint');
  const options = Array.from(dropdown.querySelectorAll('.pant-dropdown-option, .bra-dropdown-option'));
  if (!input || !trigger || !menu || !title || !options.length) return;

  dropdown.dataset.ready = 'true';

  const closeMenu = (returnFocus = false) => {
    menu.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    dropdown.classList.remove('is-open');
    if (returnFocus) trigger.focus();
  };

  const openMenu = (focusOption = false) => {
    menu.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    dropdown.classList.add('is-open');
    if (focusOption) {
      const selected = options.find(option => option.getAttribute('aria-selected') === 'true');
      (selected || options[0]).focus();
    }
  };

  const selectOption = option => {
    input.value = option.dataset.value;
    title.textContent = option.dataset.label;
    if (hint) hint.textContent = option.dataset.hint;
    dropdown.classList.add('has-value');
    options.forEach(item => item.setAttribute('aria-selected', String(item === option)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    closeMenu(true);
  };

  trigger.addEventListener('click', () => {
    if (menu.hidden) openMenu();
    else closeMenu();
  });

  trigger.addEventListener('keydown', event => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      openMenu(true);
    }
  });

  options.forEach((option, index) => {
    option.addEventListener('click', () => selectOption(option));
    option.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu(true);
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        options[(index + direction + options.length) % options.length].focus();
      }
      if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        options[event.key === 'Home' ? 0 : options.length - 1].focus();
      }
    });
  });

  document.addEventListener('click', event => {
    if (!dropdown.contains(event.target)) closeMenu();
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !menu.hidden) closeMenu(true);
  });
}


const BRA_SIZE_CHART = {
  30: { A: 'XS', B: 'XS', C: 'XS', D: 'XS' },
  32: { A: 'XS', B: 'XS', C: 'S', D: 'S', DD: 'S' },
  34: { A: 'S', B: 'S', C: 'S', D: 'M', DD: 'M' },
  36: { A: 'M', B: 'M', C: 'M', D: 'L', DD: 'L' },
  38: { A: 'L', B: 'L', C: 'L', D: 'XL', DD: 'XL' },
  40: { A: 'XL', B: 'XL', C: 'XL', D: 'XXL', DD: 'XXL' },
  42: { A: 'XXL', B: 'XXL' }
};

function updateBraResult() {
  const band = document.getElementById('braBand');
  const cup = document.getElementById('braCup');
  const result = document.getElementById('braResult');
  const resultValue = document.getElementById('braResultValue');
  if (!band || !cup || !result || !resultValue) return;

  const size = (BRA_SIZE_CHART[band.value] || {})[cup.value];
  if (size) {
    resultValue.textContent = size;
    result.hidden = false;
  } else {
    result.hidden = true;
  }
}

function initBraResult() {
  const band = document.getElementById('braBand');
  const cup = document.getElementById('braCup');
  if (band) band.addEventListener('change', updateBraResult);
  if (cup) cup.addEventListener('change', updateBraResult);
}



function initEventHandlers() {
  document.querySelectorAll('.opt[data-q]').forEach(el => {
    el.addEventListener('click', () => {
      pick(el, el.dataset.q, el.dataset.multi === 'true');
      if (el.dataset.banner) showQ3Banner(el.dataset.banner);
      if (el.dataset.silicone) handleSilicone(el.dataset.silicone);
      if (el.dataset.cervixDetail) showCervixDetail(el.dataset.cervixDetail === 'true');
      if (el.dataset.pelvicSub) showPelvicSub(el.dataset.pelvicSub === 'true');

      if (el.dataset.q === 'q15') handleQ12TravelBox(el.dataset.v);

      if (el.dataset.q === 'q12') handleQ9Tip(el.dataset.v);
    });
  });
  document.querySelectorAll('[data-acc-toggle]').forEach(el => {
    el.addEventListener('click', () => toggleAcc(el.dataset.accToggle));
  });
  document.querySelectorAll('.acc-opt[data-q]').forEach(el => {
    el.addEventListener('click', () => pickAcc(el, el.dataset.q));
  });
  document.querySelectorAll('[data-acc-filter]').forEach(el => {
    el.addEventListener('input', () => filterAcc(el.dataset.accFilter, el.value));
  });
  const accNone = document.getElementById('accNoneOpt');
  if (accNone) accNone.addEventListener('click', pickAccNone);
  document.querySelectorAll('[data-cup-action]').forEach(el => {
    el.addEventListener('click', () => {
      if (el.dataset.cupAction === 'expand') showCupSub(true);
      else skipCupModule();
    });
  });
  document.querySelectorAll('.size-btn[data-size]').forEach(el => {
    el.addEventListener('click', () => pickSize(el, el.dataset.size));
  });
  const nudge = document.getElementById('nudgeCheck');
  if (nudge) nudge.addEventListener('click', toggleNudge);
  const nudge2 = document.getElementById('nudgeCheck2');
  if (nudge2) nudge2.addEventListener('click', toggleNudge);
  const tc = document.getElementById('tcCheck');
  if (tc) tc.addEventListener('click', toggleTC);
  const introName = document.getElementById('introName');
  if (introName) introName.addEventListener('input', updateContinueBtn);
  const userFirst = document.getElementById('userFirst');
  if (userFirst) userFirst.addEventListener('input', updateContinueBtn);
  const userEmail = document.getElementById('userEmail');
  if (userEmail) userEmail.addEventListener('input', updateContinueBtn);
  const back = document.getElementById('btnBack');
  if (back) back.addEventListener('click', goBack);
  const skip = document.getElementById('btnSkip');
  if (skip) skip.addEventListener('click', skipPage);
  const cont = document.getElementById('btnContinue');
  if (cont) cont.addEventListener('click', goNext);
  initDropdowns();
  initBraResult();

  document.querySelectorAll('.prod-color select').forEach(sel => {
    sel.addEventListener('change', () => {
      const dot = sel.parentElement.querySelector('.color-dot');
      if (dot) dot.style.background = sel.selectedOptions[0].dataset.color;
    });
  });
}
initEventHandlers();


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.q-inner').forEach(function (inner) {
    const card = inner.querySelector('.why-ask');
    if (!card) return;


    const precedes = function (el) {
      return !!(el.compareDocumentPosition(card) & Node.DOCUMENT_POSITION_FOLLOWING);
    };


    const anchor =
      Array.from(inner.querySelectorAll('.q-fineprint')).find(precedes) ||
      Array.from(inner.querySelectorAll('.q-sub')).find(precedes) ||
      Array.from(inner.querySelectorAll('.q-title')).find(precedes);

    if (anchor && anchor !== card && !anchor.nextElementSibling?.classList.contains('why-ask')) {
      anchor.insertAdjacentElement('afterend', card);
    }
  });
});


showPage('intro');

